import { apiFetch } from '../../Util';

async function getSavedCartList() {
  const result = await apiFetch.index(['saved_cart']);
  return result.index;
}

export default getSavedCartList;
